import { Controller } from '@hotwired/stimulus'
import { isMobile } from '../../lib/dom'

export default class extends Controller {
  static targets = ['buttonAdvance']

  connect() {
    this.handlerReadMessage = this.readMessage.bind(this)
    this.handlerScrollToTop = this.scrollToTop.bind(this)
    window.addEventListener('message', this.handlerReadMessage)
    window.addEventListener('show.bs.modal', this.handlerScrollToTop)
  }

  disconnect() {
    window.removeEventListener('message', this.handlerReadMessage)
    window.removeEventListener('show.bs.modal', this.handlerScrollToTop)
  }

  readMessage(event) {
    if (event.data.type === 'parentScroll' && this.hasButtonAdvanceTarget) {
      this.movebuttonAdvance(event.data.clientHeight, event.data.scrollY)
    }
  }

  movebuttonAdvance(clientHeight, scrollY) {
    const adjustedScroll = scrollY + (isMobile() ? 50 : 180)
    let position = clientHeight - (isMobile() ? 450 : 600)

    if (adjustedScroll > position) {
      position += adjustedScroll - position
    }

    this.buttonAdvanceTarget.classList.add('position-absolute', 'w-100', 'pe-4')
    this.buttonAdvanceTarget.classList.remove('position-sticky', 'bottom-0')

    this.buttonAdvanceTarget.style.zIndex = 100000
    this.buttonAdvanceTarget.style.top = position + 'px'
  }

  scrollToTop() {
    window.scrollTo({ top: 0, behavior: 'smooth' })
    window.parent.postMessage({ type: 'scrollToTop' }, '*')
  }
}
